import { createStyles } from "@mantine/emotion";

export const useStylesGeneral = createStyles((theme) => ({
  wrap: {
    width: "100%",
    ".tooltip-top": {
      position: "absolute",
      right: "0",
      top: theme.spacing.stampTabContentGeneral.tooltipTop,
      [`@media (max-width: ${theme.breakpoints.mobileMax})`]: {
        display: "none",
      },
    },
    "&.stamp-text-wrap": {
      ".mantine-RichTextEditor-toolbar": {
        zIndex: "0",
      },
      "& > div > div > div": {
        maxWidth: "100%",
        ".mantine-RichTextEditor-content": {
          minHeight: theme.spacing.stampTabContentGeneral.tiptop.minHeight,
          padding: theme.spacing.stampTabContentGeneral.tiptop.padding,
          backgroundColor: theme.customBackgrounds.white,
          ".tiptap": {
            minHeight: theme.spacing.stampTabContentGeneral.tiptop.minHeight,
          },
        },
      },
    },
  },
  wrapContent: {
    alignContent: "center",
    paddingTop: theme.spacing.stampTabContentGeneral.wrapContentPaddingTop,
    width: "100%",
    boxSizing: "unset",
    ".error": {
      color: theme.customColors.red,
    },
  },
  wrapContentContainer: {
    borderRadius: theme.spacing.stampTabContentGeneral.borderRadius,
    backgroundColor: theme.customBackgrounds.verifyStampZone,
    transition: "transform 135ms ease-out",
    margin: "auto",
    border: theme.spacing.stampTabContentGeneral.dashedBorder,
    height: "auto",
    width: `calc(100% - ${theme.spacing.stampTabContentGeneral.wrapContentContainerWidthOffset})`,
    maxWidth: theme.spacing.stampTabContentGeneral.wrapContentContainerMaxWidth,
    position: "relative",
  },
  wrapContentContainerRelative: {
    position: "relative",
  },
  wrapContentContainerPadding: {
    paddingTop:
      theme.spacing.stampTabContentGeneral.wrapContentContainerPaddingTop,
    paddingBottom:
      theme.spacing.stampTabContentGeneral.wrapContentContainerPaddingBottom,
  },
  wrapContentContainerPaddingStamp: {
    paddingTop:
      theme.spacing.stampTabContentGeneral.wrapContentContainerPaddingStampTop,
    paddingBottom:
      theme.spacing.stampTabContentGeneral
        .wrapContentContainerPaddingStampBottom,
  },
  wrapContentContainerNoHash: {
    gap: theme.spacing.stampTabContentGeneral.wrapContentContainerNoHashGap,
  },
  wrapContentContainerDisabled: {
    backgroundColor: theme.customBackgrounds.stampDisabled,
  },
  dropzone: {
    display: theme.spacing.stampTabContentGeneral.dropzoneDisplay,
    justifyContent: theme.spacing.stampTabContentGeneral.dropzoneJustifyContent,
    textAlign: theme.spacing.stampTabContentGeneral.dropzoneTextAlign,
    padding: theme.spacing.stampTabContentGeneral.dropzonePadding,
    cursor: theme.spacing.stampTabContentGeneral.dropzoneCursor,
    backgroundColor: theme.customBackgrounds.verifyStampZone,
    "&:hover": {
      backgroundColor: theme.customBackgrounds.verifyStampZoneHover,
    },
  },
  dropzoneGroup: {
    display: theme.spacing.stampTabContentGeneral.dropzoneGroupDisplay,
    pointerEvents:
      theme.spacing.stampTabContentGeneral.dropzoneGroupPointerEvents,
  },
  dropzoneButton: {
    paddingLeft:
      theme.spacing.stampTabContentGeneral.dropzoneButtonPaddingLeftDesktop,
    paddingRight:
      theme.spacing.stampTabContentGeneral.dropzoneButtonPaddingRightDesktop,
    [`@media (max-width: ${theme.breakpoints.tabletMax})`]: {
      paddingLeft:
        theme.spacing.stampTabContentGeneral.dropzoneButtonPaddingLeftMobile,
      paddingRight:
        theme.spacing.stampTabContentGeneral.dropzoneButtonPaddingRightMobile,
    },
  },
  dropzoneIcon: {
    width: theme.spacing.stampTabContentGeneral.dropzoneIconSize,
    height: theme.spacing.stampTabContentGeneral.dropzoneIconSize,
    color: theme.customColors.white,
  },
  dropzoneText: {
    padding: theme.spacing.stampTabContentGeneral.dropzoneTextPadding,
    fontSize: theme.spacing.stampTabContentGeneral.dropzoneTextFontSize,
    maxWidth: theme.spacing.stampTabContentGeneral.dropzoneTextMaxWidth,
  },
  dropzoneSubText: {
    paddingTop: theme.spacing.stampTabContentGeneral.dropzoneSubTextPaddingTop,
    paddingBottom:
      theme.spacing.stampTabContentGeneral.dropzoneSubTextPaddingBottom,
    fontSize: theme.spacing.stampTabContentGeneral.dropzoneSubTextFontSize,
    fontFamily: theme.headings.fontFamily.blackLight,
  },
  dropzoneSubText2: {
    paddingTop: theme.spacing.stampTabContentGeneral.dropzoneSubText2PaddingTop,
    fontSize: theme.spacing.stampTabContentGeneral.dropzoneSubText2FontSize,
    fontFamily: theme.headings.fontFamily.blackLight,
  },
  dropzoneRemoveIcon: {
    width: theme.spacing.stampTabContentGeneral.dropzoneRemoveIconSize,
    height: theme.spacing.stampTabContentGeneral.dropzoneRemoveIconSize,
    color: theme.customColors.primary,
    marginLeft:
      theme.spacing.stampTabContentGeneral.dropzoneRemoveIconMarginLeft,
    cursor: "pointer",
    pointerEvents: "auto",
  },
  s3Section: {
    padding: theme.spacing.stampTabContentGeneral.s3SectionPadding,
    width: "100%",
  },
  s3Icon: {
    width: theme.spacing.stampTabContentGeneral.s3IconSize,
    height: theme.spacing.stampTabContentGeneral.s3IconSize,
    color: theme.spacing.stampTabContentGeneral.s3IconColor,
  },

  s3Desc: {
    fontSize: theme.spacing.stampTabContentGeneral.s3DescFontSize,
    color: theme.spacing.stampTabContentGeneral.s3DescColor,
  },
  s3FormContainer: {
    flexDirection: "column",
    gap: theme.spacing.stampTabContentGeneral.s3FormGap,
    width: "100%",
  },
  s3Input: {
    width: theme.spacing.stampTabContentGeneral.s3InputWidth,
  },
  nonAuthSection: {
    minHeight: theme.spacing.stampTabContentGeneral.nonAuthSectionMinHeight,
    maxWidth: theme.spacing.stampTabContentGeneral.nonAuthSectionMaxWidth,
    paddingTop: theme.spacing.stampTabContentGeneral.nonAuthSectionPaddingTop,
  },
  dropzoneContentBox: {
    paddingTop:
      theme.spacing.stampTabContentGeneral.dropzoneContentBoxPaddingTop,
    paddingBottom:
      theme.spacing.stampTabContentGeneral.dropzoneContentBoxPaddingBottom,
  },
  anchorPointerEvents: {
    pointerEvents: theme.spacing.stampTabContentGeneral.anchorPointerEvents,
  },
  input: {
    width: theme.spacing.stampTabContentGeneral.inputWidth,
    maxWidth: "100%",
    height: theme.spacing.stampTabContentGeneral.inputHeight,
    fontSize: theme.spacing.stampTabContentGeneral.inputFontSize,
    marginTop: theme.spacing.stampTabContentGeneral.inputMarginTop,
    background: "transparent",
    "&::placeholder": {
      fontStyle: "italic",
    },
  },
  inputInvalid: {
    border: "1px solid " + theme.customColors.red,
  },
  button: {
    padding: theme.spacing.stampTabContentGeneral.buttonPadding,
    fontSize: theme.spacing.stampTabContentGeneral.buttonFontSize,
    marginTop: theme.spacing.stampTabContentGeneral.buttonMarginTop,
    height: theme.spacing.stampTabContentGeneral.buttonHeight,
    fontFamily: theme.headings.fontFamily.light,
    marginLeft: "auto",
    marginRight: "auto",
    paddingLeft: theme.spacing.stampTabContentGeneral.buttonPaddingLeft,
    svg: {
      width: theme.spacing.stampTabContentGeneral.buttonSvgWidth,
    },
  },
  infoFileTab: {
    padding: theme.spacing.stampTabContentGeneral.infoFileTabPadding,
    borderRadius: theme.spacing.stampTabContentGeneral.infoFileTabBorderRadius,
    fontSize: theme.spacing.stampTabContentGeneral.infoFileTabFontSize,
    maxWidth: "fit-content",
    position: "relative",
    marginLeft: "auto",
    marginRight: "auto",
    img: {
      width: theme.spacing.stampTabContentGeneral.infoFileTabImgWidth,
      marginRight:
        theme.spacing.stampTabContentGeneral.infoFileTabImgMarginRight,
    },
  },

  fileDropzoneText: {
    display: "none",
    [`@media (min-width: ${theme.breakpoints.mobileMin})`]: {
      display: "block",
      fontFamily: theme.headings.fontFamily.light,
      fontSize: theme.spacing.stampTabContentGeneral.fileDropzoneFontSize,
      lineHeight: theme.spacing.stampTabContentGeneral.fileDropzoneLineHeight,
      color: theme.customColors.blackLight,
      marginTop: theme.spacing.stampTabContentGeneral.fileDropzoneMarginTop,
    },
  },
  buttonFile: {
    backgroundColor: theme.customBackgrounds.button,
    width: theme.spacing.stampTabContentGeneral.buttonFileWidth,
    padding: theme.spacing.stampTabContentGeneral.buttonPadding,
    fontSize: theme.spacing.stampTabContentGeneral.buttonFontSize,
    height: theme.spacing.stampTabContentGeneral.buttonFileHeight,
    fontFamily: theme.headings.fontFamily.light,
    marginLeft: "auto",
    marginRight: "auto",
    paddingLeft: theme.spacing.stampTabContentGeneral.buttonPaddingLeft,
    svg: {
      fill: theme.customColors.white,
      marginRight:
        theme.spacing.stampTabContentGeneral.buttonFileSvgMarginRight,
    },
    "&:hover": {
      svg: {
        fill: theme.customColors.black,
      },
    },
  },
  buttonTextFilled: {
    padding: theme.spacing.stampTabContentGeneral.buttonFilledPadding,
    marginBottom: theme.spacing.stampTabContentGeneral.buttonFilledMargin,
    [`@media (max-width: ${theme.breakpoints.mobileMax})`]: {
      marginBottom:
        theme.spacing.stampTabContentGeneral.buttonFilledMobileMargin,
    },
  },
  buttonFileHash: {
    background: "none !important",
    borderRadius: "0",
    color: theme.customBackgrounds.button,
    height: "auto",
    textDecoration: "underline !important",
    border: "none",
    width: "auto",
    fontFamily: theme.headings.fontFamily.secondary,
    fontSize: theme.spacing.stampTabContentGeneral.buttonFileHashFontSize,
    fontWeight: "normal",
    marginBottom:
      theme.spacing.stampTabContentGeneral.buttonFileHashMarginBottom,
  },
  buttonFileDisabled: {
    cursor: "default",
    backgroundColor: theme.customBackgrounds.stampButtonDisabled,
    color: theme.customColors.stampButtonDisabled,
    border: "none",
    svg: {
      opacity: "0.2",
      filter: "grayscale(100%)",
      fill: theme.customBackgrounds.black,
    },
    "&:hover": {
      backgroundColor: theme.customBackgrounds.stampButtonDisabled,
      color: theme.customColors.stampButtonDisabled,
      svg: {
        opacity: "0.2",
        filter: "grayscale(100%)",
        fill: theme.customBackgrounds.black,
      },
    },
  },
  buttonStamp: {
    fontSize: theme.spacing.stampTabContentGeneral.buttonStampFontSize,
    width: theme.spacing.stampTabContentGeneral.buttonStampWidth,
    height: theme.spacing.stampTabContentGeneral.buttonStampHeight,
    maxWidth: "100%",
    fontFamily: theme.headings.fontFamily.light,
  },
  stampFoundInfo: {
    border: theme.customColors.borderStampInfoFound,
    borderRadius:
      theme.spacing.stampTabContentGeneral.stampFoundInfoBorderRadius,
    marginBottom:
      theme.spacing.stampTabContentGeneral.stampFoundInfoMarginBottom,
    width: `calc(100% - ${theme.spacing.stampTabContentGeneral.stampFoundInfoWidthOffset})`,
    maxWidth: theme.spacing.stampTabContentGeneral.stampFoundInfoMaxWidth,
    marginLeft: "auto",
    marginRight: "auto",
  },
  stampFoundInfoImg: {
    backgroundColor: theme.customBackgrounds.stampInfoFound,
    paddingTop:
      theme.spacing.stampTabContentGeneral.stampFoundInfoImgPaddingTop,
    paddingBottom:
      theme.spacing.stampTabContentGeneral.stampFoundInfoImgPaddingBottom,
    paddingLeft:
      theme.spacing.stampTabContentGeneral.stampFoundInfoImgPaddingLeft,
    paddingRight:
      theme.spacing.stampTabContentGeneral.stampFoundInfoImgPaddingRight,
    img: {
      width: theme.spacing.stampTabContentGeneral.stampFoundInfoImgWidth,
      [`@media (min-width: ${theme.breakpoints.mobileMin})`]: {
        width:
          theme.spacing.stampTabContentGeneral.stampFoundInfoImgWidthDesktop,
      },
    },
  },
  stampFoundInfoText: {
    paddingLeft:
      theme.spacing.stampTabContentGeneral.stampFoundInfoTextPaddingLeft,
    fontSize: theme.spacing.stampTabContentGeneral.stampFoundInfoTextFontSize,
    lineHeight:
      theme.spacing.stampTabContentGeneral.stampFoundInfoTextLineHeight,
    [`@media (min-width: ${theme.breakpoints.mobileMin})`]: {
      paddingLeft:
        theme.spacing.stampTabContentGeneral
          .stampFoundInfoTextPaddingLeftDesktop,
      fontSize:
        theme.spacing.stampTabContentGeneral.stampFoundInfoTextFontSizeDesktop,
      lineHeight:
        theme.spacing.stampTabContentGeneral
          .stampFoundInfoTextLineHeightDesktop,
    },
  },
  stampFileLoaded: {
    marginBottom:
      theme.spacing.stampTabContentGeneral.stampFileLoadedMarginBottom,
    img: {
      width: theme.spacing.stampTabContentGeneral.stampFileLoadedImgWidth,
    },
    span: {
      fontSize:
        theme.spacing.stampTabContentGeneral.stampFileLoadedSpanFontSize,
      paddingLeft:
        theme.spacing.stampTabContentGeneral.stampFileLoadedSpanPaddingLeft,
    },
  },
  stampDragText: {
    display: "none",
    [`@media (min-width: ${theme.breakpoints.mobileMin})`]: {
      display: "block",
      fontFamily: theme.headings.fontFamily.light,
      fontSize: theme.spacing.stampTabContentGeneral.stampDragTextFontSize,
      lineHeight: theme.spacing.stampTabContentGeneral.stampDragTextLineHeight,
      color: theme.customColors.blackLight,
    },
  },
  stampHash: {
    display: "flex",
    flexDirection: "column",

    flexWrap: "wrap",
    bottom: theme.spacing.stampTabContentGeneral.stampHashBottom,
    left: theme.spacing.stampTabContentGeneral.stampHashLeft,
    fontSize: theme.spacing.stampTabContentGeneral.stampHashFontSize,
    color: theme.customColors.blackLight,
    fontFamily: theme.headings.fontFamily.light,
    paddingRight: theme.spacing.stampTabContentGeneral.stampHashPaddingRight,
    position: "absolute",
    [`@media (max-width: ${theme.breakpoints.mobileMax})`]: {
      fontSize: theme.spacing.stampTabContentGeneral.stampHashFontSizeMobile,
    },

    ".stamp-hash-row": {
      display: "flex",
      alignItems: "center",
      flexWrap: "wrap",
    },
    ".stamp-hash-text": {
      whiteSpace: "nowrap",
      paddingRight:
        theme.spacing.stampTabContentGeneral.stampHashTextPaddingRight,
    },
    ".stamp-hash-content": {
      wordBreak: "break-all",
      textAlign: "left",
      display: "flex",
      button: {
        top: "0",
      },
    },
    ".mantine-ActionIcon-root": {
      marginLeft:
        theme.spacing.stampTabContentGeneral.stampHashActionIconMarginLeft,
      marginTop:
        theme.spacing.stampTabContentGeneral.stampHashActionIconMarginTop,
    },
  },
  stampInfo: {
    padding: theme.spacing.stampTabContentGeneral.stampInfoPadding,
    borderRadius: theme.spacing.stampTabContentGeneral.stampInfoBorderRadius,
    fontSize: theme.spacing.stampTabContentGeneral.stampInfoFontSize,
    maxWidth: "fit-content",
    position: "relative",
    marginLeft: "auto",
    marginRight: "auto",
    img: {
      width: theme.spacing.stampTabContentGeneral.stampInfoImgWidth,
      marginRight: theme.spacing.stampTabContentGeneral.stampInfoImgMarginRight,
    },
  },
  stampFromHashInput: {
    input: {
      border: theme.spacing.stampTabContentGeneral.stampFromHashInputBorder,
      borderRadius:
        theme.spacing.stampTabContentGeneral.stampFromHashInputBorderRadius,
      fontSize: theme.spacing.stampTabContentGeneral.stampFromHashInputFontSize,
      height: theme.spacing.stampTabContentGeneral.stampFromHashInputHeight,
      lineHeight:
        theme.spacing.stampTabContentGeneral.stampFromHashInputLineHeight,
      maxWidth: "100%",
      width: "100%",
      padding: theme.spacing.stampTabContentGeneral.stampFromHashInputPadding,
      backgroundColor: theme.customBackgrounds.stampHashInput,
      color: theme.customColors.inputHashStamp,
      paddingRight:
        theme.spacing.stampTabContentGeneral.stampFromHashInputPaddingRight,
    },
  },
  stampFromHashInputWrap: {
    position: "relative",
    [`@media (max-width: ${theme.breakpoints.mobileMax})`]: {
      backgroundColor: theme.customBackgrounds.white,
      padding:
        theme.spacing.stampTabContentGeneral.stampFromHashInputWrapPadding,
    },
  },
  stampFromHashInputImg: {
    width: theme.spacing.stampTabContentGeneral.stampFromHashInputImgWidth,
    cursor: "pointer",
    position: "absolute",
    right: theme.spacing.stampTabContentGeneral.stampFromHashInputImgRight,
    top: theme.spacing.stampTabContentGeneral.stampFromHashInputImgTop,
    [`@media (max-width: ${theme.breakpoints.mobileMax})`]: {
      right:
        theme.spacing.stampTabContentGeneral.stampFromHashInputImgRightMobile,
      top: theme.spacing.stampTabContentGeneral.stampFromHashInputImgTopMobile,
    },
  },
  stampFromHashInputInvalid: {
    input: {
      border: "1px solid " + theme.customColors.red,
    },
  },
  stampFromHashInputInvalidText: {
    marginTop:
      theme.spacing.stampTabContentGeneral
        .stampFromHashInputInvalidTextMarginTop,
    position: "absolute",
    color: "red",
  },
  stampFromHashInputDisabled: {
    input: {
      backgroundColor: "hsla(0,0%,100%,.3)",
    },
  },
  stampFromHashContainer: {
    width: `calc(100% - ${theme.spacing.stampTabContentGeneral.stampFromHashContainerWidthOffset})`,
    marginLeft: "auto",
    marginRight: "auto",
    position: "relative",
    [`@media (min-width: ${theme.breakpoints.mobileMin})`]: {
      maxWidth:
        theme.spacing.stampTabContentGeneral.stampFromHashContainerMaxWidth,
    },
  },
  stampFromPortfolioContainer: {
    textarea: {
      minHeight:
        theme.spacing.stampTabContentGeneral.portfolio.textarea.minHeight,
    },
    [`@media (max-width: ${theme.breakpoints.mobileMax})`]: {
      textarea: {
        minHeight:
          theme.spacing.stampTabContentGeneral.portfolio.textarea
            .minHeightMobile,
      },
    },
    ".example-text": {
      color: theme.customColors.blackLight,
    },
    ".portfolio-preview-wrap": {
      paddingTop: theme.spacing.stampTabContentGeneral.previewPadding,
    },
    ".portfolio-preview": {
      backgroundColor: theme.customBackgrounds.white,

      borderRadius: theme.spacing.stampTabContentGeneral.borderRadius,
      padding: theme.spacing.stampTabContentGeneral.previewPadding,
      fontFamily: theme.headings.fontFamily.light,

      margin: 0,
      maxHeight: theme.spacing.modalCreate.previewMaxHeight,
      overflowY: "auto",
      overflowX: "auto",
    },
    ".portfolio-dropzone": {
      position: "relative",
      borderRadius: theme.spacing.stampTabContentGeneral.borderRadius,
      transition: "all 0.2s ease",
    },
    ".portfolio-textarea-wrapper": {
      position: "relative",
      opacity: "0.7",
    },
    ".portfolio-placeholder": {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      pointerEvents: "none",
      paddingTop:
        theme.spacing.stampTabContentGeneral.portfolio.placeholder.padding.top,
      paddingBottom:
        theme.spacing.stampTabContentGeneral.portfolio.placeholder.padding
          .bottom,
      paddingLeft:
        theme.spacing.stampTabContentGeneral.portfolio.placeholder.padding.left,
      paddingRight:
        theme.spacing.stampTabContentGeneral.portfolio.placeholder.padding
          .right,
      fontSize: theme.fontSizes.sm,
      fontFamily: theme.fontFamily,
      lineHeight: theme.lineHeight,
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing.stampTabContentGeneral.portfolio.placeholder.gap,
      zIndex: 1,
      p: {
        lineHeight:
          theme.spacing.stampTabContentGeneral.portfolio.placeholder.p
            .lineHeight,
      },
      strong: {
        lineHeight:
          theme.spacing.stampTabContentGeneral.portfolio.placeholder.strong
            .lineHeight,
      },
      ul: {
        paddingBottom:
          theme.spacing.stampTabContentGeneral.portfolio.placeholder.ul
            .paddingBottom,
      },
      li: {
        lineHeight:
          theme.spacing.stampTabContentGeneral.portfolio.placeholder.li
            .lineHeight,
      },
      a: {
        pointerEvents: "auto",
      },
    },
    ".portfolio-placeholder-text": {
      color: theme.colors.gray[6],
      fontSize: theme.fontSizes.sm,
      fontFamily: theme.fontFamily,
      lineHeight: theme.lineHeight,
    },
    ".portfolio-placeholder-bold": {
      fontWeight: "bold",
    },
    ".portfolio-dropzone-active": {
      border: `2px dashed ${theme.customColors.blue}`,
      backgroundColor: "rgba(34, 139, 230, 0.05)",
    },
    ".portfolio-dropzone-overlay": {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "rgba(34, 139, 230, 0.1)",
      pointerEvents: "none",
      borderRadius: theme.spacing.stampTabContentGeneral.borderRadius,
    },
    ".portfolio-dropzone-overlay-text": {
      fontSize: theme.fontSizes.lg,
      fontWeight: 500,
      color: theme.customColors.blue,
    },
    ".portfolio-upload-section": {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
    },
    ".portfolio-status-valid": {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing.xs,
      marginTop: theme.spacing.xs,
      color: theme.customColors.green,
      fontSize: theme.spacing.sm,
      fontWeight: 500,
    },
    ".portfolio-status-invalid": {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing.xs,
      marginTop: theme.spacing.xs,
      color: theme.customColors.red,
      fontSize: theme.spacing.sm,
      fontWeight: 500,
    },
    ".portfolio-docs-link": {
      marginTop: theme.spacing.md,
      fontSize: theme.spacing.sm,
    },
    ".portfolio-upload-hint": {
      paddingRight: "1em",
    },
    ".portfolio-normalized-note": {
      marginTop: theme.spacing.xs,
      fontSize: theme.spacing.md,

      lineHeight: 1.5,
    },
    ".portfolio-hidden-input": {
      display: "none",
    },
  },
  buttonFileUpload: {
    backgroundColor: theme.customBackgrounds.button,
    width: "auto",
    padding: `${theme.spacing.xxs} ${theme.spacing.md}`,
    fontSize: theme.spacing.stampTabContentGeneral.buttonFontSize,
    height: "auto",
    minHeight: "2.5em",
    fontFamily: theme.headings.fontFamily.light,
    marginLeft: 0,
    marginRight: 0,
    "&:hover": {
      backgroundColor: theme.customBackgrounds.buttonHover,
    },
  },
  stampFromFileContainer: {},
  stampFromTextContainer: {},
  stampHashMobileLogin: {
    marginTop:
      theme.spacing.stampTabContentGeneral.stampHashMobileLoginMarginTop,
    textAlign: "center",
  },
  stampHashText: {
    marginTop: theme.spacing.stampTabContentGeneral.stampHashTextMarginTop,
    marginBottom:
      theme.spacing.stampTabContentGeneral.stampHashTextMarginBottom,
    [`@media (max-width: ${theme.breakpoints.mobileMax})`]: {
      alignItems: "flex-start",
      marginLeft: "auto",
      marginRight: "auto",
      maxWidth: theme.spacing.stampTabContentGeneral.stampHashTextMaxWidth,
    },
    img: {
      width: theme.spacing.stampTabContentGeneral.stampHashTextImgWidth,
      marginRight:
        theme.spacing.stampTabContentGeneral.stampHashTextImgMarginRight,
      opacity: "0",
      [`@media (min-width: ${theme.breakpoints.mobileMin})`]: {
        display: "none",
      },
    },
    p: {
      fontSize: theme.spacing.stampTabContentGeneral.stampHashTextFontSize,
      lineHeight: theme.spacing.stampTabContentGeneral.stampHashTextLineHeight,
    },
    span: {
      fontSize: theme.spacing.stampTabContentGeneral.stampHashTextFontSize,
      lineHeight: theme.spacing.stampTabContentGeneral.stampHashTextLineHeight,
    },
  },
  stampHashTextFirst: {
    img: {
      opacity: "1",
      display: "block",
    },
  },

  stampBulkText: {
    border: theme.customColors.borderBulk,
    backgroundColor: theme.customBackgrounds.bulkBlock,
    fontFamily: theme.headings.fontFamily.light,
    marginTop: theme.spacing.stampTabContentGeneral.stampBulkTextMarginTop,
    width: "100%",
    marginBottom:
      theme.spacing.stampTabContentGeneral.stampBulkTextMarginBottom,
    textAlign: "center",
    fontSize: theme.spacing.stampTabContentGeneral.stampBulkTextFontSize,
    lineHeight: theme.spacing.stampTabContentGeneral.stampBulkTextLineHeight,
    paddingTop: theme.spacing.stampTabContentGeneral.stampBulkTextPaddingTop,
    paddingBottom:
      theme.spacing.stampTabContentGeneral.stampBulkTextPaddingBottom,
    marginLeft: theme.spacing.stampTabContentGeneral.stampBulkTextMarginLeft,
    marginRight: theme.spacing.stampTabContentGeneral.stampBulkTextMarginRight,
    maxWidth: theme.spacing.stampTabContentGeneral.stampBulkTextMaxWidth,
    [`@media (min-width: ${theme.breakpoints.mobileMin})`]: {
      width: "auto",
      marginBottom:
        theme.spacing.stampTabContentGeneral.stampBulkTextMarginBottomDesktop,
      fontSize:
        theme.spacing.stampTabContentGeneral.stampBulkTextFontSizeDesktop,
      lineHeight:
        theme.spacing.stampTabContentGeneral.stampBulkTextLineHeightDesktop,
      padding: theme.spacing.stampTabContentGeneral.stampBulkTextPaddingDesktop,
      maxWidth:
        theme.spacing.stampTabContentGeneral.stampBulkTextMaxWidthDesktop,
      marginLeft: "auto",
      marginRight: "auto",
    },
    [`@media (max-width: ${theme.breakpoints.mobileMax})`]: {
      fontFamily: theme.headings.fontFamily.bold,
    },
  },
  resourceTabButton: {
    backgroundColor: theme.customBackgrounds.white,
    color: theme.customColors.black,
    fontSize: theme.spacing.stampTabContentGeneral.resourceTabButtonFontSize,
    border: "1px solid " + theme.customBackgrounds.blackPrimary,
    "&:hover": {
      backgroundColor: theme.customBackgrounds.blackPrimary,
      color: theme.customColors.white,
    },
    "&.active": {
      backgroundColor: theme.customBackgrounds.blackPrimary,
      color: theme.customColors.white,
    },
    span: {
      fontWeight: "normal",
    },
  },
  resourceSubmitButton: {
    backgroundColor: theme.customBackgrounds.blackPrimary,
    color: theme.customColors.white,
    fontSize: theme.spacing.stampTabContentGeneral.resourceSubmitButtonFontSize,
    border: "1px solid " + theme.customBackgrounds.blackPrimary,
    "&:hover": {
      backgroundColor: theme.customBackgrounds.white,
      color: theme.customColors.black,
    },
  },
  ringProgressContainer: {
    paddingTop:
      theme.spacing.stampTabContentGeneral.ringProgressContainerPaddingTop,
  },
  ringProgressLabel: {
    textAlign: theme.spacing.stampTabContentGeneral.ringProgressLabelTextAlign,
    fontSize: theme.fontSizes.sm,
    fontWeight:
      theme.spacing.stampTabContentGeneral.ringProgressLabelFontWeight,
  },
}));
